package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Serializer

@Serializable
data class GetClubPlayerResponse(
    val data: List<GetClubPlayerData>,
)
@Serializable
data class GetClubPlayerData(
    val id: String= "",
    val rev: String = "",
    val coachName: String = "",
    val email: String = "",
    val firstName: String = "",
    val organization: String = "",
    val role: String = "",
    val type: String = "",
    val uid: String = "",
    val lastName: String = "",
)
